<template>
  <div class="flex items-center justify-end space-x-2">
    <base-select
      :expand="false"
      :shadow="false"
      :options="filterStatusOptions"
      v-model="filter.status"
      @change="$emit('filter')"
    />
    <base-search
      class="h-10"
      placeholder="Cari Kode"
      v-model="filter.search"
      v-on:input="$emit('search')"
    />
  </div>
</template>

<script>
import BaseSearch from '@/components/base/Search.vue';

export default {
  components: {
    BaseSearch,
  },
  emits: ['input', 'filter', 'search'],
  props: {
    value: Object,
  },
  computed: {
    filter: {
      get() {
        return this.value;
      },
      set(value) {
        this.$emit('input', value);
      },
    },
    filterStatusOptions() {
      return [
        {
          value: null,
          label: 'Semua',
          key: 'Semua',
        },
        {
          value: 'draft',
          label: 'Belum Dikirim',
          key: 'Belum Dikirim',
        },
        {
          value: 'shipped',
          label: 'Terkirim',
          key: 'Terkirim',
        },
        {
          value: 'received',
          label: 'Diterima',
          key: 'Diterima',
        },
      ];
    },
  },
};
</script>
